<template>
  <div class="footer">
    <div class="container">
      <div class="row contact">
        <div class="col-lg-3 col-md-6 text-center text-md-left">
          <p>
            CURADEN Slovakia s.r.o.<br>
            Na Výslní 17<br>
            82105 Bratislava
          </p>
        </div>
        <div class="col-lg-3 col-md-6 text-center text-md-left pb-5">
          <a href="tel:+421245527913">+421 2 455 279 13</a><br>
          <a href="mailto:info@curaprox.sk">info@curaprox.sk</a><br>
          <a href="//curaprox.sk" target="_blank">www.curaprox.sk</a>
        </div>
        <div class="col-lg-6 text-center text-lg-right">
          <FooterItem :imgUrl="'/static/img/footer-shop.png'" :title="'Chcem nakúpiť'" :url="'https://shop.curaprox.sk/32-zubne-pasty-be-you'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-pin.png'" :title="'Zoznam Smile shopov'" :url="'https://www.curaprox.com/sk-sk/dealer-search'"></FooterItem>
        </div>
      </div>
      <div class="row social">
        <div class="col-md-12 text-center p-t-20">
          <FooterItem :imgUrl="'/static/img/footer-fb.png'" :title="'Facebook'" :url="'https://www.facebook.com/curaproxslovensko'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig.png'" :title="'Instagram'" :url="'https://www.instagram.com/curaproxslovensko/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-p.png'" :title="'Pinterest'" :url="'https://sk.pinterest.com/curaproxslovensko/?eq=curapro&etslf=4548'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-yt.png'" :title="'Youtube'" :url="'https://www.youtube.com/user/curaproxsk '"></FooterItem>
        </div>
      </div>
      <div class="row instagram">
        <div class="col-md-12 text-center p-t-20">
          <h3>Ktorému dáš follow?</h3>
        </div>
        <div class="col-md-12 text-center p-t-20">
          <FooterItem :imgUrl="'/static/img/footer-ig-01.png'" :title="''" :url="'https://www.instagram.com/be_daydreamer_be_you/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig-02.png'" :title="''" :url="'https://www.instagram.com/be_explorer_be_you/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig-03.png'" :title="''" :url="'https://www.instagram.com/be_risingstar_be_you/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig-04.png'" :title="''" :url="'https://www.instagram.com/be_purehappiness_be_you/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig-05.png'" :title="''" :url="'https://www.instagram.com/be_candylover_be_you/'"></FooterItem>
          <FooterItem :imgUrl="'/static/img/footer-ig-06.png'" :title="''" :url="'https://www.instagram.com/be_challenger_be_you/'"></FooterItem>
        </div>
      </div>
      <div class="row swiss">
        <div class="col-md-12 text-center text-md-right">
          <router-link :to="{name: 'Gdpr'}" style="float: left" target="_blank">Zásady používania online identifikátorov</router-link>
          <img src="/static/img/footer-swiss.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterItem from './FooterItem.vue'

export default {
  data () {
    return {
    }
  },
  components: {
    FooterItem
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/css/variables.scss";

  .footer {
    padding: 60px 0 30px 0 ;
    background-color: $color-blue-footer;
    color: $color-white;
    font-size: 19px;
    a {
      color: $color-white;
      &:hover {
        color: $color-white;
      }
    }
    .social {
      padding: 20px 0 30px 0;
    }
    .swiss {
      /*padding-top: 30px;*/
    }
    h3 {
      padding-bottom: 30px;
      font-size: 20px;
      font-weight: 700;
    }

    @media (max-width: $breakpoint-md) {
      padding: 40px 0 20px 0;
      p {
        margin-bottom: 40px;
      }
      .social {
        padding-top: 0;
      }
      .instagram .footer-item {
        width: 90px;
        padding-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue